import { render, staticRenderFns } from "./classReport.vue?vue&type=template&id=c3723954&"
import script from "./classReport.vue?vue&type=script&lang=js&"
export * from "./classReport.vue?vue&type=script&lang=js&"
import style0 from "./classReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports